import firebase from "../../firebase";

export default function(data) {
    return firebase.functions().httpsCallable("allFunctions")({
        funcRole: "billingAdmin",
        funcName: "createCustomPlan",
        data
    });
}
